import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useAppConfig } from "../lib/appConfig";
import { ShareThoughts } from "./ShareThoughts";

// Global disclaimer modal. Opened from the About menu (and reusable anywhere via openDisclaimer()).
// It reuses the feedback-modal chrome (fb-overlay / fb-modal) so the two read as one family, and
// carries the ShareThoughts card so a reader can leave feedback in the same place.

/** Open the global disclaimer modal from anywhere (mirrors openFeedback()). */
export function openDisclaimer() {
  window.dispatchEvent(new CustomEvent("open-disclaimer"));
}

/** Mount once (in Base.tsx). */
export function DisclaimerDialog() {
  const [open, setOpen] = useState(false);
  const cfg = useAppConfig();

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("open-disclaimer", onOpen);
    return () => window.removeEventListener("open-disclaimer", onOpen);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="fb-overlay print:hidden"
      role="dialog"
      aria-modal="true"
      aria-label="Disclaimer"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) setOpen(false);
      }}
    >
      <div className="fb-modal">
        <div className="fb-modal-head">
          <div>
            <div className="fb-modal-title">Disclaimer</div>
            <div className="fb-modal-sub mono">How to read this site</div>
          </div>
          <button type="button" className="icon-btn" aria-label="Close" onClick={() => setOpen(false)}>
            <X size={18} />
          </button>
        </div>
        <p className="disclaimer-text">{cfg.footer.disclaimerText}</p>
        <ShareThoughts className="disclaimer-share" />
      </div>
    </div>
  );
}
